<ng-container *transloco="let t">
  @let hasReceivers = channels.length > 0 || users.length > 0 || mailAddresses.length > 0;
  <div class="flex flex-1 flex-col">
    <tui-stepper class="mb-6 justify-start" [(activeItemIndex)]="currentPage">
      <button
        tuiStep
        type="button"
        [stepState]="
          currentPage !== SharePickerPage.SELECT_RECEIVERS && !hasReceivers
            ? 'error'
            : !hasReceivers
              ? 'normal'
              : 'pass'
        ">
        {{ t('Destinataires') }}
      </button>
      <button tuiStep type="button">{{ t('Message') }}</button>
    </tui-stepper>

    <section class="flex flex-1 flex-col" pxcSlidesScrollReset [tuiSlides]="slideDirection">
      @if (currentPage === SharePickerPage.SELECT_RECEIVERS) {
        <pxc-receivers-picker
          [(selectedChannels)]="channels"
          [(selectedMailAddresses)]="mailAddresses"
          [(selectedUsers)]="users" />
      }

      @if (currentPage === SharePickerPage.MESSAGE) {
        <div class="flex flex-col gap-8 pb-8" data-testid="summary">
          <div>
            <p class="mb-2">{{ t('Vérifiez les informations qui seront partagées') }}</p>
            <ng-content />
          </div>
          <div>
            <p class="mb-2 text-sm">{{ t('Destinataires') }}</p>
            @if (hasReceivers) {
              <pxc-receiver-list
                [channels]="channels"
                [mailAddresses]="mailAddresses"
                [removable]="false"
                [users]="users" />
            } @else {
              <pxc-empty-state icon="@tui.user-x" [title]="t('Vous devez sélectionner au moins un destinataire !')" />
            }
          </div>
          <label tuiLabel>
            {{ t('Ajouter un message') }}
            <tui-textfield class="flex-1">
              <textarea
                tuiTextarea
                [formControl]="shareText"
                [minRows]="2"
                [placeholder]="t('Entrez un message')"></textarea>
            </tui-textfield>
          </label>
        </div>
      }
    </section>
    <footer class="mt-auto!" tuiFloatingContainer>
      <div class="flex justify-between gap-2">
        <button
          appearance="outline"
          data-testid="cancel-page-button"
          tuiButton
          type="button"
          (click)="currentPage === 0 ? close() : previous()">
          {{ currentPage === 0 ? t('Annuler') : t('Précédent') }}
        </button>
        <button data-testid="next-page-button" tuiButton type="button" [disabled]="!hasReceivers" (click)="next()">
          {{ currentPage === SharePickerPage.MESSAGE ? t('Confirmer') : t('Suivant') }}
        </button>
      </div>
    </footer>
  </div>
</ng-container>
